"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("../../../common/Button/Button"));
var ImagePicker_1 = __importDefault(require("../../../common/ImagePicker/ImagePicker"));
var Spinner_1 = __importDefault(require("../../../common/Spinner/Spinner"));
var Table_1 = __importDefault(require("../../../common/Table/Table"));
var TextInput_1 = __importDefault(require("../../../common/TextInput/TextInput"));
var Toast_1 = require("../../../common/Toast");
var org_hook_1 = require("../../../context/OrgContext/org.hook");
var getLanguages_1 = require("../../../lib/getLanguages");
var icons_1 = __importDefault(require("../../../theme/icons"));
var SortingSelector_1 = __importDefault(require("../Disease/Selectors/SortingSelector"));
var Mutation_1 = require("./Graphql/Mutation");
var Queries_1 = require("./Graphql/Queries");
require("./Style/style.scss");
var react_modal_1 = __importDefault(require("react-modal"));
var AddDiseaseForm = function (props) {
    var _a, _b, _c;
    var organization = (0, org_hook_1.useOrg)().organization;
    var _d = (0, react_i18next_1.useTranslation)(), i18n = _d.i18n, t = _d.t, iconRef = react_1.default.createRef(), _e = (0, react_1.useState)([
        {
            id: null,
            name: {},
            icon: null,
            sorting_order: null,
            organization_id: null,
            disease_type_id: null,
            scientific_name: {},
            description: {},
            published: null,
        },
    ]), fields = _e[0], setFields = _e[1], 
    // [languages, setLanguages] = useState({
    //   en: "",
    //   fr: "",
    //   rn: "",
    // }),
    _f = (0, react_1.useState)([{ icon: "" }]), fileName = _f[0], setFileName = _f[1], _g = (0, react_1.useState)([]), error = _g[0], setError = _g[1], _h = (0, react_1.useState)(false), isOpen = _h[0], setIsOpen = _h[1], 
    // [deleteConfirmation, setDeleteConfirmation] = useState(false),
    _j = (0, client_1.useMutation)(Mutation_1.DELETE_DISEASE, {
        fetchPolicy: "no-cache",
        refetchQueries: [Queries_1.GET_DISEASES, "getDiseasesList"],
    }), deleteDisease = _j[0], deleteDiseaseResponse = _j[1], triggerButton = function () { return (react_1.default.createElement("div", { className: "absoulte-buttom" },
        react_1.default.createElement(Button_1.default, { className: "form-buttom", icon: react_1.default.createElement(icons_1.default, { name: "plus", className: "icon", height: 30, width: 30 }), text: t("add_disease"), onClick: function () { return setIsOpen(true); } }))); };
    console.log("delete", deleteDiseaseResponse);
    // addTextInput = () => {
    //   const values = [...fields];
    //   values.push({
    //     id: null,
    //     name: {
    //       en: "",
    //       fr: "",
    //       rn: "",
    //     },
    //     icon: null,
    //     sorting_order: null,
    //     organization_id: organization.id,
    //     disease_type_id: null,
    //     published: null,
    //     scientific_name: {
    //       en: "",
    //       fr: "",
    //       rn: "",
    //     },
    //     description: {
    //       en: "",
    //       fr: "",
    //       rn: "",
    //     },
    //   });
    //   setFields(values);
    //   const file_name: any = [...fileName];
    //   file_name.push({ icon: "" });
    //   setFileName(file_name);
    // },
    // removeTextInput = (i: number) => {
    //   const values = [...fields];
    //   values.splice(i, 1);
    //   setFields(values);
    //   const file_name: any = [...fileName];
    //   file_name.splice(i, 1);
    //   setFileName(file_name);
    // };
    (0, react_1.useEffect)(function () {
        getLanguageList();
    }, []);
    var getLanguageList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var list;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, getLanguages_1.getLanguages)()];
                case 1:
                    list = _a.sent();
                    // setLanguages(list);
                    setFields([
                        {
                            id: null,
                            name: list,
                            icon: null,
                            sorting_order: null,
                            organization_id: organization.id,
                            disease_type_id: null,
                            scientific_name: list,
                            description: list,
                            published: null,
                        },
                    ]);
                    return [2 /*return*/];
            }
        });
    }); };
    function handleChange(i, value, type) {
        setError([]);
        var values = __spreadArray([], fields, true);
        if (type === "name") {
            values[i][type][i18n.language] = value;
        }
        // else if (type === "scientific_name") {
        //   values[i][type] = value;
        // } else if (type === "description") {
        //   values[i][type] = value;
        // }
        else if (type === "sorting_order") {
            values[i][type] = value;
        }
        else {
            values[i][type] = value;
            var file_name = __spreadArray([], fileName, true);
            file_name[i].icon = value.name;
            setFileName(file_name);
        }
        setFields(values);
    }
    var resetForm = function () {
        setFields([
            {
                id: null,
                name: {
                    en: "",
                    fr: "",
                    rn: "",
                },
                icon: null,
                sorting_order: null,
                organization_id: organization.id,
                disease_type_id: null,
                scientific_name: {
                    en: "",
                    fr: "",
                    rn: "",
                },
                description: {
                    en: "",
                    fr: "",
                    rn: "",
                },
                published: null,
            },
        ]);
        setFileName([{ icon: "" }]);
        // IconRef.current.value = null;
    }, onSaveClick = function () {
        var tmp = [], errortmp = [];
        fields.map(function (l, i) {
            if (l.name[i18n.language] === "") {
                errortmp.push({
                    type: "name",
                    message: "required",
                    index: i,
                });
            }
            else {
                var id = l.id, name_1 = JSON.stringify(l.name), icon = l.icon, scientific_name = JSON.stringify(l.scientific_name), description = JSON.stringify(l.description), sorting_order = l.sorting_order
                    ? parseInt(l.sorting_order)
                    : null;
                // parent_id: any = l.parent_id ? parseInt(l.parent_id) : null;
                tmp.push({
                    id: id,
                    name: name_1,
                    icon: icon,
                    sorting_order: sorting_order,
                    scientific_name: scientific_name,
                    description: description,
                    organization_id: organization.id,
                    disease_type_id: null,
                });
            }
        });
        if (tmp.length === fields.length && tmp.length > 0) {
            props.onSaveClick(tmp);
        }
        else {
            setError(errortmp);
        }
    }, createUI = function () { return (react_1.default.createElement(react_1.default.Fragment, null, fields.map(function (item, idx) {
        var _a;
        var findIndex = error.length > 0 &&
            error.find(function (i) { return i.index === idx; });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "inner-content", key: idx },
                react_1.default.createElement(TextInput_1.default, { error: findIndex &&
                        findIndex.index === idx &&
                        findIndex.type === "name" &&
                        findIndex.message, label: t("name"), onChange: function (e) {
                        return handleChange(idx, e.target.value, "name");
                    }, value: (_a = item === null || item === void 0 ? void 0 : item.name) === null || _a === void 0 ? void 0 : _a[i18n.language] }),
                react_1.default.createElement(ImagePicker_1.default, { fileName: fileName[idx], id: "icon", imagechange: function (file) { return handleChange(idx, file, "icon"); }, imgref: iconRef, label: t("icon"), mediatype: "image" }),
                react_1.default.createElement(SortingSelector_1.default, { list: props.list ? props.list : [], label: "sorting_order", onChange: function (e) {
                        handleChange(idx, e.sorting_id, "sorting_order");
                    }, value: item.sorting_order }))));
    }))); };
    {
        /* <div className="inner-content" key={idx}> */
    }
    (0, react_1.useEffect)(function () {
        if (props.isSuccess) {
            resetForm();
        }
    }, [props.isSuccess]);
    var onEditClick = function (item) {
        var parsedName = JSON.parse(item.name);
        var parsedScientificName = JSON.parse(item.scientific_name);
        var parsedDescription = JSON.parse(item.description);
        setFields([
            {
                id: item.id,
                name: parsedName,
                icon: null,
                sorting_order: item.sorting_order,
                organization_id: organization.id,
                disease_type_id: null,
                scientific_name: parsedScientificName,
                description: parsedDescription,
                published: null,
            },
        ]);
    }, onDeleteClick = function (item) {
        deleteDisease({
            variables: {
                id: item.id,
                organization_id: item.organization_id,
            },
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (props.getResponse.loading || (deleteDiseaseResponse === null || deleteDiseaseResponse === void 0 ? void 0 : deleteDiseaseResponse.loading)) && (react_1.default.createElement(Spinner_1.default, null)),
        (deleteDiseaseResponse === null || deleteDiseaseResponse === void 0 ? void 0 : deleteDiseaseResponse.data) && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, 
            // message={t("deleted_successfully")}
            message: (_a = deleteDiseaseResponse === null || deleteDiseaseResponse === void 0 ? void 0 : deleteDiseaseResponse.data) === null || _a === void 0 ? void 0 : _a.deleteDisease, newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: "top-center", rtl: false })),
        triggerButton(),
        react_1.default.createElement(react_modal_1.default, { isOpen: isOpen, onRequestClose: function () {
                setIsOpen(false);
                resetForm();
            }, contentLabel: "Add Category Modal", style: {
                content: {
                    top: "50%",
                    left: "50%",
                    right: "auto",
                    bottom: "auto",
                    marginRight: "-50%",
                    transform: "translate(-50%, -50%)",
                    width: "75%",
                    height: "75%",
                },
            } },
            react_1.default.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                } },
                react_1.default.createElement("h2", null, t("add_disease")),
                react_1.default.createElement("div", { style: {
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "1rem",
                        marginBottom: "1rem",
                    } },
                    react_1.default.createElement(Button_1.default, { className: "modal-button", onClick: function () {
                            setIsOpen(false);
                            resetForm();
                        }, icon: react_1.default.createElement(icons_1.default, { name: "cancel", className: "icon", height: 20, width: 20 }) }),
                    react_1.default.createElement(Button_1.default, { className: "modal-button", icon: react_1.default.createElement(icons_1.default, { name: "tick", className: "icon", height: 30, width: 30 }), onClick: function () {
                            onSaveClick();
                            setIsOpen(false);
                        }, style: { marginLeft: 2 } }))),
            createUI(),
            react_1.default.createElement(Table_1.default, { list: ((_c = (_b = props.getResponse) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.getDiseasesList)
                    ? props.getResponse.data.getDiseasesList
                    : [], 
                // OnDeleteClick={delete_confirm}
                onDeleteClick: onDeleteClick, onEditClick: onEditClick }))));
};
exports.default = AddDiseaseForm;
